import React, { useEffect, useState } from 'react';
import Spinner from '../../../../Constants/Spinner';
import pause from '../../../../Assets/Images/pause.png';
import TicIcon from '../../../../Assets/Icons/TicIcon';
import PlayIcon from '../../../../Assets/Icons/PlayIcon';
import DeleteIcon from '../../../../Assets/Icons/DeleteIcon';
import UploadIcon from '../../../../Assets/Icons/UploadIcon';
import { assetURL } from '../../../../api/utils';
import PostTextEditor from './components/PostTextEditor';

function PostFormData({
  postObj,
  setPostObj,
  formFunction,
  audioName,
  setAudioName,
  getBookPostData,
  editState,
  postNumber,
  isPostLoading,
}) {
  const [confirmLoader, setConfirmLoader] = useState(false);
  const [audioMp3, setAudioMp3] = useState('');
  const [played, setPlayed] = useState(false);
  const [disabled, setDisable] = useState(false);
  function playAudio() {
    if (postObj.recitation_audio || postObj.recitation_audio_url) {
      setPlayed(true);
      var x = document.getElementById('myAudio');
      x.load(); //call this to just preload the audio without playing
      x.play();
    }
  }

  function pauseAudio() {
    if (postObj.recitation_audio || postObj.recitation_audio_url) {
      setPlayed(false);
      var x = document.getElementById('myAudio');
      x.pause();
    }
  }
  useEffect(() => {
    if (confirmLoader) {
      setDisable(true);
    } else if (postObj.reference && postObj.post_number && postObj.content) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [postObj, confirmLoader]);

  useEffect(() => {
    if (postObj.recitation_audio) {
      var files = postObj.recitation_audio;
      let url = URL.createObjectURL(files);

      setAudioMp3(url);
    }
  }, [postObj, editState]);

  return (
    <span key={postNumber}>
      <h4 className="text-2xl font-extrabold mt-6">Post {getBookPostData && getBookPostData.length + 1}</h4>
      <div className="postDetailInner f px-8 bg-[#eef2f0] rounded-s-lg  mt-[16px] py-6 w-full">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center justify-between flex-wrap w-full">
            <div className="postRef md:w-[48%] w-full">
              <div className="references">
                <p className="text-sm text-black font-semibold">Reference</p>
                <input
                  value={postObj.reference}
                  placeholder="Write Post reference"
                  dir={postObj.reference ? 'rtl' : 'ltr'}
                  className="rounded-xl mt-[16px] text-[14px] border-[1px] border-[#dde4de] w-full h-[56px] px-6 outline-none text-[#7b867c]"
                  onChange={ev => {
                    let obj = { ...postObj };
                    obj.reference = ev.target.value;
                    setPostObj(obj);
                  }}
                />
              </div>
            </div>
            <div className="postNumber md:w-[48%] w-full">
              <div className="Number md:w-[50%] w-full">
                <p className="text-sm text-black font-semibold">Post Number</p>
                <input
                  value={postObj.post_number}
                  dir={postObj.post_number ? 'rtl' : 'ltr'}
                  placeholder="Write Post Number"
                  className="rounded-xl mt-[16px] text-[14px] border-[1px] border-[#dde4de] w-full h-[56px] px-6 outline-none text-[#7b867c]"
                  onChange={ev => {
                    let obj = { ...postObj };
                    obj.post_number = ev.target.value;
                    setPostObj(obj);
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <p className="text-sm text-black mt-6 font-semibold w-full flex justify-between">Post Text </p>

        <PostTextEditor //
          isPostLoading={isPostLoading}
          postContent={postObj.content}
          onChange={({ postContent, postPreview }) =>
            setPostObj({ ...postObj, content: postContent, preview: postPreview })
          }
        />

        <p className="font-semibold mt-6">Add Recitation</p>
        {editState || audioMp3 ? (
          <audio id="myAudio">
            <source
              src={
                audioMp3
                  ? audioMp3
                  : editState?.recitation_audio_url
                  ? editState?.recitation_audio_url
                  : `${assetURL}${editState?.recitation_audio}`
              }
              type="audio/mp3"
            />
            <source
              src={
                audioMp3
                  ? audioMp3
                  : editState?.recitation_audio_url
                  ? editState?.recitation_audio_url
                  : `${assetURL}${editState?.recitation_audio}`
              }
              type="audio/mp3"
            />
            Your browser does not support the audio element.
          </audio>
        ) : null}
        <div className="flex items-center justify-between mt-4 md:flex-row flex-col">
          <div className="uplaodRecite sm:w-[60%] md:w-full md:max-w-[508px]  w-full">
            <label className="flex	 justify-between items-center  rounded-xl border-[1px] border-[#dde4de] w-full px-6 bg-white">
              <p className="w-[90%] outline-0 h-[56px] text-sm text-[#7B867C] mb-0 flex items-center">
                Select from your computer
              </p>
              <input
                type="file"
                accept=".mp3"
                className="hidden"
                placeholder="Select from your computer"
                onChange={ev => {
                  if (ev.target.files && ev.target.files[0]) {
                    let obj = { ...postObj };
                    obj.recitation_audio = ev.target.files[0];
                    setAudioName(ev.target.files[0].name);
                    setPostObj(obj);
                  }
                }}
              />
              <UploadIcon />
            </label>
          </div>
          <div className="md:w-[calc(100%-538px)] sm:w-[38%] w-full flex items-center justify-between">
            <div className="flex items-center w-[calc(100%-40px)]">
              {played ? (
                <button
                  className="bg-[#2a9134] w-[40px] h-[40px] rounded-full flex items-center justify-center"
                  onClick={pauseAudio}>
                  <img className="h-[30%]" src={pause} />
                </button>
              ) : (
                <button
                  className="bg-[#2a9134] w-[40px] h-[40px] rounded-full flex items-center justify-center"
                  onClick={playAudio}>
                  <PlayIcon />
                </button>
              )}
              <p className="mx-[8px] font-semibold  text-text-ellipsis w-[calc(100%-40px)]">
                {audioName ? audioName : `Audio Name.mp3`}
              </p>
            </div>
            {audioName && (
              <button
                className="bg-[#ca3030] w-[40px] h-[40px] rounded-full flex items-center justify-center"
                onClick={() => {
                  let obj = { ...postObj };
                  obj.recitation_audio = '';
                  setAudioName('');
                  setAudioMp3('');
                  setPostObj(obj);
                }}>
                <DeleteIcon pathProp={{ fill: '#fff' }} />
              </button>
            )}
          </div>
        </div>
      </div>
      <button
        disabled={disabled}
        className="relative flex items-center justify-center mt-6 rounded-xl py-4 bg-white  text-[#2a9134] border-[1px] leading-[8px] outline-none border-[#2a9134] px-9  w-full font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={() => formFunction(setConfirmLoader)}>
        {confirmLoader ? <Spinner /> : null}
        <span
          className={confirmLoader ? `opacity-0 flex items-center justify-center` : 'flex items-center justify-center'}>
          <TicIcon className="mr-1.5" stroke="#2a9134" />
          Confirm
        </span>
      </button>
    </span>
  );
}

export default PostFormData;
